// @givmo/app-charity — the Organization section's "Connected accounts" card (CBG-CAL1 slice 1d;
// the approved frames `org-accounts`, `-attention`, `-disconnect`; question 1).
//
// Org machinery, declared by this host on the settings authority's CAPABILITY (`write_settings`,
// which no module switch masks), never a tier: every account outside Givmo the organization lets Givmo
// use, and the one place a Global Admin can still see and disconnect them while Board is off. The card
// is Board's (`@givmo/board`'s `ConnectedAccountsCard`: today's only purpose is Board's meetings, and a
// calendar that still sends meetings gets Board's choice before it goes); this host hands it what the
// composer does not — whether Board is ON for the organization, off the console's one standing read
// (`verdictFor`: off, still setting up or absent means Board's choices and routes stay out).
//
// Dark until served: it renders nothing while core does not serve the list, or lists nothing.
//
// DATA CONTRACT: `org-settings-organization-connected-accounts` (the composer's slot) around the
// card's own `org-connected-accounts` family.

import { ConnectedAccountsCard } from '@givmo/board';
import { verdictFor, type OrganizationSettingsCardProps } from '@givmo/org-console';
import { useCharityConsole } from '../../console/charity-console-context';

/** The board module's slug, as the console's one standing read keys it. */
const BOARD = 'board';

export function OrgConnectedAccountsCard({
  orgRef,
  config,
  permissions,
}: OrganizationSettingsCardProps) {
  const { standings } = useCharityConsole();
  const verdict = verdictFor(standings, BOARD);
  return (
    <ConnectedAccountsCard
      orgRef={orgRef}
      permissions={permissions}
      userId={config.selfUserId ?? null}
      orgName={config.vocab.orgName ?? null}
      boardOn={verdict === 'link' || verdict === 'locked'}
    />
  );
}
